import { defineTransform } from "../transform";

// Object operations are completely independent of stack operations.
defineTransform("stack_delete", "create_object", (op1, op2, side) => op1);
defineTransform("stack_delete", "delete_object", (op1, op2, side) => op1);
defineTransform("stack_delete", "update_property", (op1, op2, side) => op1);

// op2 has already happened, transform op1
defineTransform("stack_delete", "stack_create", (op1, op2, side) => {
  // Same item.
  if (op2.p[1] <= op1.p[1]) {
    return { p: ["stack", op1.p[1] + 1], ds: op1.ds };
  }

  return op1;
});

// op2 has already happened, transform op1
defineTransform("stack_delete", "stack_delete", (op1, op2, side) => {
  // Both are attempting to delete the same value.
  if (op1.ds === op2.ds) {
    if (op1.p[1] === op2.p[1]) {
      // Keep op2, and don't do op1.
      return;
    }
  }

  // It is impossible to delete different IDs from the same index.
  if (op1.ds !== op2.ds && op2.p[1] === op1.p[1]) {
    throw new Error(
      `stack_delete vs stack_delete at same index for ${op1.ds},${op2.ds} at ${op1.p[1]}`
    );
  }

  // Unrelated delete operations. Adjust indexes if necessary.
  if (op2.p[1] < op1.p[1]) {
    return { p: ["stack", op1.p[1] - 1], ds: op1.ds };
  }

  return op1;
});
